export { ArrowChevronRight1 } from "./ArrowChevronRight1";
